import styled from 'styled-components/macro';
import appIcon from '../../assets/app_icon.svg';

export const MobileWrapper = styled.div<{ isTablet: boolean }>`
  box-sizing: border-box;
  padding: ${(props) => (props.isTablet ? '8px 32px' : '8px 16px')};
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const LogoBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const TextBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const Icon = styled.img.attrs({
  src: appIcon,
})<{ isTablet: boolean }>`
  width: ${(props) => (props.isTablet ? '48px' : '40px')};
  height: ${(props) => (props.isTablet ? '48px' : '40px')};
`;
